import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { Flex } from "@rebass/grid/emotion"

const lineH = "20.8"

export const DisclaimerBox = styled(Flex)`
  //NT2-17442 prevent copy jump Skin pages with Root Causes module, Using microbiome as longest copy
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  /* min-height: ${9 * lineH}px; */

  @media (min-width: 339px) {
    /* min-height: ${8 * lineH}px; */
  }

  @media (min-width: 383px) {
    /* min-height: ${7 * lineH}px; */
  }

  @media (min-width: 432px) {
    /* min-height: ${6 * lineH}px; */
  }

  @media (min-width: 502px) {
    /* min-height: ${5 * lineH}px; */
  }

  @media (min-width: 607px) {
    /* min-height: ${4 * lineH}px; */
  }

  @media (min-width: 768px) and (max-width: 823px) {
    /* min-height: ${9 * lineH}px; */
  }

  @media (min-width: 824px) {
    /* min-height: auto; */
  }

  @media (min-width: 1024px) {
    align-items: flex-end;
  }

  p {
    @media (min-width: 768px) and (max-width: 1023px) {
      width: 234px;
      /* margin: auto; */
    }
  }
`

export const IngredientsContainer = styled.div`
  background-color: ${theme.wild.color.nova.base.black};
  padding: 40px 24px !important;

  @media (min-width: 768px) {
    padding: 48px 32px !important;
  }

  @media (min-width: 1024px) {
    padding: 80px 112px !important;
  }

  .heading {
    margin-bottom: 40px;

    @media (min-width: 1024px) {
      margin-bottom: 80px;
    }
  }

  .inner-container {
    display: flex;
    height: 100%;
    max-width: 1376px;
    margin: 0 auto;
  }

  .modal-button {
    margin-top: 40px;

    @media (min-width: 768px) {
      margin-left: auto;
      margin-right: auto;
    }

    @media (min-width: 1024px) {
      margin-top: 80px;
    }

    .textelement {
      color: ${theme.wild.color.nova.base.white};
    }
  }

  .left-column {
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
      width: 50%;
      padding: 25px;
      border: 1px solid ${theme.wild.color.nova.transparency.white[20]};
      border-radius: 4px 0 0 4px;
      border-right: none;
    }

    @media (min-width: 1263px) {
      // Set to 1263px to account for the large button size on 1024px and up
      padding: 80px;
    }
  }

  .mobile-image-box {
    margin-bottom: 16px;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .desktop-image-box {
    position: relative;
    flex-shrink: 0;
    display: none;

    @media (min-width: 768px) {
      display: block;
      border-radius: 0 4px 4px 0;
      overflow: hidden;
    }
  }

  @media (max-width: 767px) {
    .inner-container {
      display: flex;
      flex-direction: column-reverse;

      .right-column {
        margin: 0 auto;
      }
    }

    .left-column {
      padding-left: 0;
      padding-right: 0;
    }
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 40px;

  &.mobile {
    @media (min-width: 1024px) {
      display: none;
    }
  }

  &.desktop {
    display: none;

    @media (min-width: 1024px) {
      display: flex;
    }
  }
`
